export default __webpack_public_path__ + "static/background-image-9c170b4981c64defc92e70bdbafaea69.jpg";